// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 2 ? "vendor-base" : chunkId) + "-" + {"2":"f67d5fac8b0201029f11","416":"a905a8335bd3da35b52f"}[chunkId] + ".css";
};